import { apiSlice } from '../apiSlice';
import { Variety } from '../schemas/variety';
import { providesList } from '../utils/providesList';

const varietyEndpoints = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getVariety: builder.query<Variety, string>({
      query: (id) => ({
        url: `/varieties/${id}`,
      }),
      transformResponse: (response: Variety) => {
        // trim trailing whitespace from stage names
        return {
          ...response,
          stages: response.stages.map((stage) => ({
            ...stage,
            name: stage.name.trim(),
          })),
        };
      },
      providesTags: (result, error, id) => [{ type: 'Variety', id }],
    }),
    getVarietiesForCustomer: builder.query<
      Variety[],
      { customerId: string; cropTypes?: string | string[] }
    >({
      query: ({ customerId, cropTypes }) => ({
        url: `/customers/${customerId}/varieties`,
        params: {
          ...(cropTypes ? { crop_type__in: cropTypes } : {}),
        },
      }),
      transformResponse: (response: Variety[]) => {
        return response.map((variety) => ({
          ...variety,
          stages: variety.stages.map((stage) => ({
            ...stage,
            name: stage.name.trim(),
          })),
        }));
      },
      providesTags: (result) => providesList(result, 'Variety'),
    }),
  }),
});

export const { useGetVarietiesForCustomerQuery, useGetVarietyQuery } =
  varietyEndpoints;
